(function () {
  const settings = window.theme && theme.settings;
  const strings = window.theme && theme.strings;

  if (!settings) return;

  const thresholdCents = parseInt(settings.freegiftThreshold, 10) * 100;
  const giftVariantId = settings.freegiftProduct;

  // Adding needs the feature on, an eligible customer and a usable threshold.
  // Removing needs none of those: an ineligible visitor, or one browsing after
  // the feature was switched off, must still lose a gift line already in cart.
  const canAddGift =
    Boolean(settings.enableFreeGift) &&
    Boolean(settings.freeGiftEligible) &&
    Boolean(giftVariantId) &&
    Number.isFinite(thresholdCents);

  if (!canAddGift && !settings.freeGiftInCart) return;

  // Checkout and the order can only render a property as "key: value", so the
  // gift line carries the translated pair. The cart hides the value and shows
  // the key on its own.
  const propertyName = strings && strings.freeGiftPropertyName;
  const propertyText = strings && strings.freeGiftProductText;
  const jsonHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  let isSyncing = false;

  function isGiftLine(item) {
    const props = item.properties || {};
    return Boolean(props._free_gift);
  }

  function findGiftLines(cart) {
    return (cart.items || []).filter(isGiftLine);
  }

  function setCheckoutDisabled(disabled) {
    document.querySelectorAll('[name="checkout"]').forEach((btn) => {
      btn.disabled = disabled;
      btn.classList.toggle('disabled', disabled);
    });
  }

  async function fetchCart() {
    const res = await fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  }

  async function postJson(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(body),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(json.description || json.message || res.statusText);
    }
    return json;
  }

  async function setFreeGiftAttribute(value) {
    await postJson(window.routes.cart_update_url, {
      attributes: { free_gift: value ? 'true' : 'false' },
    });
  }

  async function changeGiftQuantity(key, quantity) {
    await postJson(window.routes.cart_change_url, {
      id: key,
      quantity: quantity,
    });
  }

  async function addGift() {
    const properties = { _free_gift: 'true' };
    if (propertyName) properties[propertyName] = propertyText;

    await postJson(`${window.routes.cart_add_url}.js`, {
      id: giftVariantId,
      quantity: 1,
      properties: properties,
    });
    await setFreeGiftAttribute(true);
  }

  // Refresh without dispatching 'ajaxProduct:added': that event makes CartItems
  // call renderAndShowItems(), which force-opens the cart drawer.
  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:update'));
    document.querySelectorAll('cart-items').forEach((cartItems) => {
      if (typeof cartItems.renderItems === 'function') cartItems.renderItems();
    });
  }

  async function syncFreeGift() {
    if (isSyncing) return;
    isSyncing = true;
    setCheckoutDisabled(true);

    let mutated = false;

    try {
      const cart = await fetchCart();
      const giftLines = findGiftLines(cart);
      const shouldHaveGift = canAddGift && cart.total_price >= thresholdCents;

      if (shouldHaveGift) {
        const [keptLine, ...extraLines] = giftLines;

        if (!keptLine) {
          await addGift();
          mutated = true;
        } else if (keptLine.quantity > 1) {
          await changeGiftQuantity(keptLine.key, 1);
          mutated = true;
        }

        for (const extraLine of extraLines) {
          await changeGiftQuantity(extraLine.key, 0);
          mutated = true;
        }
      } else if (giftLines.length) {
        for (const giftLine of giftLines) {
          await changeGiftQuantity(giftLine.key, 0);
        }
        await setFreeGiftAttribute(false);
        mutated = true;
      }

      if (mutated) refreshCartUi();
    } catch (err) {
      console.error(err);
    } finally {
      setCheckoutDisabled(false);
      isSyncing = false;
    }
  }

  document.addEventListener('ajaxProduct:added', syncFreeGift);
  document.addEventListener('cart:update', syncFreeGift);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFreeGift);
  } else {
    syncFreeGift();
  }
})();
